<style lang="less" scoped>
  @import "../../../../style/theme.less";

</style>

<template>
  <div>
    <a-page-header
      @back="() => $router.go(-1)"
      title="Normalisation Vector Details"
      :sub-title="id"
      style="padding: 0; margin-bottom: 8px"
    >
      <template slot="extra">
        <a-button type="primary" shape="circle" icon="reload" @click="() => getNormalisationVectorDetails(id)"/>
      </template>
    </a-page-header>

    <a-row :gutter="[16, 16]">
      <a-col :span="12">
        <a-descriptions title="Normalisation Vector Information" bordered :column="1">
          <a-descriptions-item label="ID">{{ normalisationVectorDetails.id }}</a-descriptions-item>
          <a-descriptions-item label="Created At">{{ normalisationVectorDetails.createdAt | timestamp }}</a-descriptions-item>
          <a-descriptions-item label="Updated At">{{ normalisationVectorDetails.updatedAt | timestamp }}</a-descriptions-item>
        </a-descriptions>
      </a-col>
      <a-col :span="12">
        <conditions-display
          v-if="normalisationVectorDetails.condition && normalisationVectorDetails.condition.conditions"
          title="Conditions"
          :conditions="normalisationVectorDetails.condition.conditions"
        />
      </a-col>
    </a-row>

    <div class="spacer-lg" />

    <div class="ant-descriptions-title">Normalisation Vector Weights</div>
    <a-table
      :columns="columns"
      :data-source="formattedWeights"
      :pagination="false"
      :rowKey="({ id }) => id"
      :rowClassName="({ id }) => id === highlightedWeightId ? 'highlighted' : ''"
    />
  </div>
</template>

<script>

import { mapState, mapActions } from 'vuex';

import conditionsDisplay from '../../../../components/shared/conditions/display';

const columns = [
  {
    title: 'ID',
    dataIndex: 'id',
  }, {
    title: 'Personality Trait',
    dataIndex: 'personalityTrait',
  }, {
    title: 'Dividend',
    dataIndex: 'dividend',
  }, {
    title: 'Divisor',
    dataIndex: 'divisor',
  },
];

export default {
  name: 'admin.normalisation-vectors.details',

  data: () => ({
    id: undefined,
    highlightedWeightId: undefined,

    columns,
  }),

  components: {
    conditionsDisplay,
  },

  mounted() {
    this.id = this.$route.params.id;
    if (!this.id) {
      return this.$router.push({ name: 'admin.normalisation-vectors', });
    }

    this.highlightedWeightId = this.$route.params.weightId;

    return this.getNormalisationVectorDetails(this.id);
  },

  computed: {
    ...mapState('admin', ['normalisationVectorDetails',]),

    formattedWeights() {
      if (!this.normalisationVectorDetails.weights) {
        return [];
      }

      return this.normalisationVectorDetails.weights.map(({ id, dividend, divisor, personalityTrait, }) => {

        return { id, dividend, divisor, personalityTrait: `(${personalityTrait.code}) ${personalityTrait.descriptor}`, };
      });
    },
  },

  methods: {
    ...mapActions('admin', ['getNormalisationVectorDetails',]),
  },
};
</script>
